import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/shared/layout/Header";
import { Header as AuthHeader } from "@/shared/layout/authenticatedHeader/Header";
import { Footer } from "@/shared/layout/Footer";
import { routes } from "@/app/navigation/routes";
import { useAuth } from "@/app/providers/useAuth";
import styles from "./NonAuthenticatedLayout.module.css";

/**
 * Layout for non-authenticated routes
 * Includes header and footer, but no sidebar
 */
export const NonAuthenticatedLayout = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const isLandingPage = location.pathname === routes.home || location.pathname === routes.landing;
  const isHomeScreen = location.pathname === routes.homepage;
  const isSelectPropertyType = location.pathname === routes.selectPropertyType;

  return (
    <div className={styles.nonAuthenticatedLayout}>
      {isAuthenticated || isHomeScreen ? <AuthHeader /> : <Header />}
      <main className={`${styles.mainContent} ${isLandingPage ? styles.landingPage : ""}`}>
        <Outlet />
      </main>
      {!isLandingPage && !isHomeScreen && !isSelectPropertyType && <Footer />}
    </div>
  );
};
